<template>
  <BasicModal
    :title="t('c.25090381')"
    size="middle"
    :zIndex="1031"
    @register="registerModal"
    @ok="saveCacheList"
  >
    <div class="menuBox">
      <div class="content flex">
        <div class="left w-160px">
          <div class="mb-12px font-500 text-[#131A24]">
            {{ t('c.25090382') }} （{{ collectMenu.length }}/8）
          </div>
          <div
            v-for="item in collectMenu"
            :key="item.name"
            class="mb-12px flex items-center justify-between"
          >
            <span>{{ t(item.name) }}</span>
            <MinusCircleOutlined class="cursor-pointer" @click="handelRemove(item)" />
          </div>
        </div>
        <div class="right flex-1">
          <div class="mb-12px font-500 text-[#131A24]">{{ t('c.25090383') }}</div>
          <div>
            <div v-for="item in menuModules" :key="item.name">
              <div v-for="childrenMenu in item.children" :key="childrenMenu.path">
                <div class="text-16px font-600 mb-8px mt-16px">{{ t(childrenMenu.name) }}</div>
                <Row
                  v-if="!childrenMenu.hideMenu && !childrenMenu.hideChildrenInMenu"
                  :gutter="[12, 12]"
                >
                  <template v-for="thirdMenu in childrenMenu.children" :key="thirdMenu.path">
                    <Col :span="8">
                      <div class="flex justify-between">
                        <span>{{ t(thirdMenu.name) }}</span>
                        <span
                          ><PlusCircleFilled
                            v-if="isExist(thirdMenu.path)"
                            class="cursor-pointer"
                            :style="{ color: '#01A887' }"
                            @click="handleAdd(thirdMenu)"
                        /></span>
                      </div>
                    </Col>
                  </template>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BasicModal>
</template>

<script lang="ts" setup>
  import { MinusCircleOutlined, PlusCircleFilled } from '@ant-design/icons-vue';
  import { Col, Row } from 'ant-design-vue';
  import { computed, onMounted, ref, watch } from 'vue';
  import type { RouteLocationNormalized } from 'vue-router';
  import { message } from '@mts-fe/utils';
  import { BasicModal, useModalInner } from '@mts/components/Modal';
  import { t } from '@mts/hooks/web/useI18n';
  import { listenerRouteChange } from '@mts/logics/mitt/routeChange';
  import API, { parseConfigValue } from '@/api/ims-system';
  import { getMenus } from '@/router/menus';
  import type { Menu } from '@/router/types';
  import { getPermissionStore } from '@/store';

  defineProps({
    //最多展示菜单数量
    maxCount: {
      type: Number,
      default: 8,
    },
  });

  let menuModules = ref<Menu[]>([]);
  onMounted(() => {
    menuModules.value = getMenus();
  });

  // Menu changes
  const permissionStore = getPermissionStore();
  watch(
    [() => permissionStore.getLastBuildMenuTime, () => permissionStore.getBackMenuList],
    () => {
      menuModules.value = getMenus();
    },
    { immediate: true },
  );

  const currentRoute = ref<RouteLocationNormalized | null>(null);
  listenerRouteChange((route) => {
    currentRoute.value = route;
  });

  const [registerModal, { closeModal }] = useModalInner(() => {
    getCacheList();
  });

  //添加收藏菜单
  const collectMenu = ref<Menu[]>([]);
  const isExist = computed(() => {
    return (path) => {
      const curMenu = collectMenu.value.find((item) => item.path === path);
      return !curMenu;
    };
  });

  const hasEdit = ref(false);
  const handleAdd = (menu: Menu) => {
    const curMenu = collectMenu.value.find((item) => item.path === menu.path);
    if (curMenu) return;
    if (collectMenu.value.length > 7) {
      return message.error(t('c.25090384'));
    }
    hasEdit.value = true;
    collectMenu.value.push(menu);
  };

  //移除收藏菜单
  const handelRemove = (menu: Menu) => {
    hasEdit.value = true;
    collectMenu.value = collectMenu.value.filter((item) => item.path !== menu.path);
  };

  //获取当前收藏的菜单
  const getCacheList = async () => {
    const data = await API.getSysConfig({ configKey: 'ims-collect-menu' }).then(parseConfigValue);
    if (!Array.isArray(data)) return;
    collectMenu.value = data;
  };

  //保存当前收藏的菜单
  const saveCacheList = async () => {
    const configValue = JSON.stringify(collectMenu.value);
    try {
      await API.saveSysConfig({ configKey: 'ims-collect-menu', configValue });
      message.success(t('c.25090363'));
      closeModal();
      hasEdit.value && location.reload();
    } catch (error) {}
  };
</script>
<style lang="less" scoped>
  .menuBox {
    height: 100%;
    line-height: 24px;

    .header {
      padding: 0 12px;
      border-bottom: 1px solid #dfe5ec;
    }

    .content {
      height: 100%;

      .left {
        padding: 12px;
        border-right: 1px solid #dfe5ec;
      }

      .right {
        height: 100%;
        padding: 12px;
        overflow-y: auto;
      }
    }

    .footer {
      height: 48px;
      padding: 0 12px;
    }
  }
</style>
